"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Error = void 0;
var React = require("react");
var Error = function (props) {
    var _a, _b;
    var error = (_b = (_a = props.errors) === null || _a === void 0 ? void 0 : _a[props.field]) === null || _b === void 0 ? void 0 : _b[0];
    return error ? React.createElement("div", { className: 'validation-error' }, error) : null;
};
exports.Error = Error;
